import axiosInstance from "../Utils/axiosInstance";
import { LinksApi } from "../Constants/api";

export const getLinksApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${LinksApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};
